var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 20.19V72.5242C16.8438 74.3717 16.8438 77.7486 16.8482 79.4901C18.5793 79.4901 21.9622 79.4901 23.8096 79.4901H93.4684C94.3921 79.4901 96.9513 79.4901 96.9513 79.4901C96.9513 77.7486 96.9513 76.9309 96.9513 76.0072V27.246C96.9513 26.3223 96.9513 23.7631 96.9513 23.7631C96.9513 23.7631 94.3921 23.7631 93.4684 23.7631H88.3333M16.8438 20.19C16.8438 24.5956 20.0155 23.7631 23.8096 23.7631H88.3333M16.8438 20.19C16.8438 15.7845 20.0155 16.6186 23.8096 16.6186H83.0196C88.3333 16.6186 88.3333 19.7628 88.3333 23.7631",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3308 52.3399C88.5146 52.3399 89.4742 51.3803 89.4742 50.1966C89.4742 49.0128 88.5146 48.0532 87.3308 48.0532C86.1471 48.0532 85.1875 49.0128 85.1875 50.1966C85.1875 51.3803 86.1471 52.3399 87.3308 52.3399Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 49.1445C80.5 45.1987 83.6987 42 87.6445 42H96.5V58H87.6445C83.6987 58 80.5 54.8013 80.5 50.8555V49.1445Z",
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1348,
    cy: 89.4353,
    r: 23.3647,
    transform: "rotate(45 91.1348 89.4353)",
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 2.03171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2245 97.8903C84.6294 98.4854 83.6646 98.4854 83.0695 97.8903C82.4744 97.2952 82.4744 96.3304 83.0695 95.7353L88.9764 89.8285L83.0694 83.9214C82.4743 83.3263 82.4743 82.3615 83.0694 81.7665C83.6644 81.1714 84.6292 81.1714 85.2243 81.7665L91.1314 87.6735L97.0379 81.7669C97.633 81.1719 98.5978 81.1719 99.1929 81.767C99.7879 82.362 99.7879 83.3268 99.1929 83.9219L93.2863 89.8285L99.1927 95.7349C99.7878 96.3299 99.7878 97.2947 99.1927 97.8898C98.5976 98.4849 97.6328 98.4849 97.0378 97.8898L91.1314 91.9834L85.2245 97.8903Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 62.0002C41.6667 58.1669 51.9 52.8002 63.5 62.0002",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1136 47.5975C34.7231 47.988 34.0899 47.988 33.6994 47.5975C33.3089 47.207 33.3089 46.5738 33.6994 46.1833L36.4842 43.3984L33.6992 40.6134C33.3086 40.2228 33.3086 39.5897 33.6992 39.1992C34.0897 38.8086 34.7228 38.8086 35.1134 39.1992L37.8984 41.9842L40.6835 39.1992C41.074 38.8086 41.7072 38.8086 42.0977 39.1992C42.4882 39.5897 42.4882 40.2228 42.0977 40.6134L39.3127 43.3984L42.0975 46.1833C42.488 46.5738 42.488 47.207 42.0975 47.5975C41.707 47.988 41.0738 47.988 40.6833 47.5975L37.8984 44.8127L35.1136 47.5975Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1136 47.5975C59.7231 47.988 59.0899 47.988 58.6994 47.5975C58.3089 47.207 58.3089 46.5738 58.6994 46.1833L61.4842 43.3984L58.6992 40.6134C58.3086 40.2228 58.3086 39.5897 58.6992 39.1992C59.0897 38.8086 59.7228 38.8086 60.1134 39.1992L62.8984 41.9842L65.6835 39.1992C66.074 38.8086 66.7072 38.8086 67.0977 39.1992C67.4882 39.5897 67.4882 40.2228 67.0977 40.6134L64.3127 43.3984L67.0975 46.1833C67.488 46.5738 67.488 47.207 67.0975 47.5975C66.707 47.988 66.0738 47.988 65.6833 47.5975L62.8984 44.8127L60.1136 47.5975Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/emptyTable.ad71e2b3d209e9413348db13e70a7d6f.svg";
export { ForwardRef as ReactComponent };